import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'
import { CategoryId } from '~/models/category/types'

export const xymaSearchConfig: SearchConfig = Object.freeze({
  settings: {
    viewType: {
      defaultViewTypeDesktop: ViewType.GALLERY,
      defaultViewTypeMobile: ViewType.GALLERY
    },
    searchName: 'xyma',
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/query/',
      usesNuxtLinks: true
    },
    stats: {
      record: true
    },
    displayAds: true
  },
  rootParams: {
    category: [CategoryId.XYMA]
  }
})
